import React from "react";

interface StatisticsCardProps {
  icon: React.ReactNode;
  count: number;
  label: string;
  iconBgColor: string;
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({
  icon,
  count,
  label,
  iconBgColor,
}) => {
  return (
    <div className="stat-card">
      <div className="stat-card-content">
        <div className="stat-icon" style={{ backgroundColor: iconBgColor }}>
          {icon}
        </div>
        <div className="stat-info">
          <h2>{count}</h2>
          <p>{label}</p>
        </div>
      </div>
    </div>
  );
};

export default StatisticsCard;
